import { AxiosResponse } from 'axios';

export class HTTPResponseException extends Error {
  readonly status: number;
  readonly data: any;

  constructor(error: Error & { response: AxiosResponse }) {
    super(error.message);
    Object.setPrototypeOf(this, HTTPResponseException.prototype);
    this.name = HTTPResponseException.name;
    this.status = error.response.status;
    this.data = error.response.data;
  }

  get dataMessage(): string | undefined {
    return this.data?.message;
  }

  get unauthorized() {
    return this.status === 401;
  }

  get forbidden() {
    return this.status === 403;
  }
}

export function isHTTPResponseException(e: any): e is HTTPResponseException {
  return e instanceof HTTPResponseException;
}
